import { createContext, useContext } from "react";

export interface RowVisibilityItem {
  id: string;
  label: string;
}

export interface RowVisibility {
  rows: RowVisibilityItem[];
  hiddenRowGroupIds: Set<string>;
  toggleRowGroup: (rowGroupId: string) => void;
}

const RowVisibilityContext = createContext<RowVisibility | null>(null);

export const RowVisibilityProvider = RowVisibilityContext.Provider;

export const useRowVisibility = (): RowVisibility => {
  const value = useContext(RowVisibilityContext);
  if (!value) {
    throw new Error(
      "useRowVisibility must be used within a RowVisibilityProvider",
    );
  }
  return value;
};
